import React from "react";
import { MapPin, Phone, Mail, Instagram, Twitter, Youtube } from "lucide-react";
import { FadeUp } from "@/components/shared/RevealText";

export default function ContactSection() {
    return (
        <section className="relative border-t border-ink/10 bg-slate-25 py-24 md:py-32" data-testid="contact-section">
            <div className="container-x">
                <div className="mb-16 grid grid-cols-1 items-end gap-8 md:grid-cols-12">
                    <FadeUp className="md:col-span-7">
                        <div className="eyebrow mb-4">Ch. 10 · Reach us</div>
                        <h2 className="h-display font-display text-[40px] font-black leading-[0.95] text-ink md:text-[64px]">
                            Let&apos;s stay
                            <br />
                            in <span className="serif-italic text-pink">touch</span>.
                        </h2>
                    </FadeUp>
                    <FadeUp delay={0.1} className="md:col-span-5">
                        <p className="max-w-md text-[15px] leading-relaxed text-slate-600 md:text-[16px]">
                            For partnerships, press or platform feedback, reach out through any of the channels below.
                        </p>
                    </FadeUp>
                </div>

                <div className="grid grid-cols-1 gap-6 md:grid-cols-12">
                    <div className="md:col-span-5 space-y-4">
                        {[
                            { Icon: MapPin, label: "Office", value: "6-3-1090 Somajiguda, Hyderabad, 500082" },
                            { Icon: Phone, label: "Phone", value: "+91 40 0000 0000" },
                            { Icon: Mail, label: "Email", value: "hello@meetwithktr.concept" },
                        ].map(({ Icon, label, value }, i) => (
                            <div key={i} className="flex items-start gap-5 rounded-[22px] border border-ink/10 bg-white p-6" data-testid={`contact-info-${i}`}>
                                <div className="grid h-11 w-11 shrink-0 place-items-center rounded-full border border-ink/10">
                                    <Icon className="h-4 w-4 text-pink" />
                                </div>
                                <div>
                                    <div className="text-[11px] font-semibold uppercase tracking-[0.24em] text-slate-500">
                                        {label}
                                    </div>
                                    <div className="mt-1 font-display text-[17px] font-semibold text-ink">{value}</div>
                                </div>
                            </div>
                        ))}
                        <div className="flex items-center gap-3">
                            {[Instagram, Twitter, Youtube].map((Icon, i) => (
                                <a
                                    key={i}
                                    href="#"
                                    onClick={(e) => e.preventDefault()}
                                    className="grid h-11 w-11 place-items-center rounded-full border border-ink/10 text-ink transition-colors hover:border-pink hover:text-pink"
                                    aria-label="social"
                                >
                                    <Icon className="h-4 w-4" />
                                </a>
                            ))}
                        </div>
                    </div>
                    <div className="md:col-span-7">
                        <div className="relative aspect-[16/10] overflow-hidden rounded-[22px] border border-ink/10">
                            <img
                                src="https://images.unsplash.com/photo-1621909054851-14a56b3a44a0?auto=format&fit=crop&w=1400&q=80"
                                alt="Hyderabad — Charminar"
                                className="h-full w-full object-cover grayscale"
                            />
                            <div className="pointer-events-none absolute inset-0 bg-gradient-to-t from-white/40 to-transparent" />
                            <div className="absolute left-6 top-6 rounded-full border border-ink/10 bg-white/90 px-4 py-2 text-[11px] font-semibold uppercase tracking-[0.22em] text-ink backdrop-blur">
                                Hyderabad · Concept map
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}
